import { partnersApi } from 'api';
import { PartnerSearchResponse } from 'pco-product-service-internal-consumer';

/**
 *
 *
 * @param {string} searchTerm - this can be the partner name OR number
 * @return {*}
 */

export const fetchPartnerByNameOrNumber = async (searchTerm: string): Promise<PartnerSearchResponse[]> => {
  return await partnersApi.searchPartners({
    partnersSearchRequest: {
      searchTerm: searchTerm || undefined,
      limitResults: searchTerm ? -1 : 10,
    },
  });
};
